// This file is auto-generated by the min-height registry build step.
// Do not edit this file directly.
//
// HOW TO ADD A NEW COMPONENT TO THE REGISTRY:
//
// export const COMPONENT_MIN_HEIGHT = {
//   sm: '10rem',
//   md: '12rem',
//   lg: '14rem',
//   xl: '16rem'
// };
//
// Component.minHeights = COMPONENT_MIN_HEIGHT;
//
// The build step will automatically update this registry.

export const MIN_HEIGHT_REGISTRY = {
  HeroRail: {
    xl: '22.125rem',
    lg: '22.125rem',
    md: '22.125rem',
    sm: '20.3125rem'
  },
  PromoGroup: {
    xl: '18.875rem',
    lg: '13.688rem',
    md: '10.75rem',
    sm: '10.563rem'
  },
  ShowCaseHero: {
    xl: '32.375rem',
    lg: '32.9375rem',
    md: '30.125rem',
    sm: '34.4375rem'
  },
  PromotedCardMini: {
    xl: '3.5rem',
    lg: '3.5rem',
    md: '3.5rem',
    sm: '3.5rem'
  },
  Hero: {
    xl: '14.5rem',
    lg: '14.5rem',
    md: '11.5rem',
    sm: '11.5rem'
  },
  Banner: {
    xl: '10.5rem',
    lg: '10.5rem',
    md: '10.5rem',
    sm: '10.5rem'
  }
};

export default MIN_HEIGHT_REGISTRY;
